module.exports = __webpack_public_path__ + "static/img/vingcard.12e5cae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/合作夥伴/vingcard.jpg?20181011
// module id = /JIk
// module chunks = 1